import React from "react";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { Reveal, Overline, MaskLines } from "../components/Motion";
import { FOUNDERS } from "../lib/data";

export default function About() {
  return (
    <div>
      {/* Header */}
      <section className="pt-40 md:pt-52 pb-20 relative z-10" data-testid="about-header">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Overline>About Ethikally</Overline>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight mt-6 font-medium">
            <MaskLines lines={["Why we started", <span key="e" className="italic text-forest">Ethikally.</span>]} delay={0.1} />
          </h1>
        </div>
      </section>

      {/* Philosophy */}
      <section className="pb-24 md:pb-32 relative z-10" data-testid="philosophy-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <div className="font-mono text-forest text-xs tracking-[0.22em] uppercase sticky top-28">Our standard</div>
          </div>
          <div className="md:col-span-9">
            <Reveal>
              <p className="font-heading text-2xl md:text-3xl lg:text-[2.5rem] leading-[1.35] text-navy">
                Ethikally was founded on a simple observation: financial advice in India is too often conflicted, oversimplified, or inaccessible to the people who need it most. Our standard is straightforward — recommend only what we would do with our own money, and explain the reasoning in plain terms, every time.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-navy/60 text-lg leading-relaxed mt-10 max-w-3xl">
                Across our team, we've sat on both sides of the table — underwriting credit risk, auditing public companies, and managing investment portfolios. That's the lens we bring to every engagement: rigorous, evidence-based, and built to hold up under scrutiny, not just sound good in a pitch.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Founders */}
      <section className="bg-navy text-cream py-24 md:py-36 relative z-10" data-testid="founders-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Overline>The team</Overline>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl mt-4 tracking-tight text-cream mb-16">
            One team. One standard.
          </h2>
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
            {FOUNDERS.map((f, i) => (
              <Reveal key={f.name} delay={i * 0.1}>
                <div data-testid={`founder-card-${i}`}>
                  <div className="overflow-hidden clip-frame h-96 group">
                    <img src={f.photo} alt={f.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                  </div>
                  <h3 className="font-heading text-3xl md:text-4xl mt-8 tracking-tight text-cream">{f.name}</h3>
                  <p className="font-mono text-xs tracking-[0.15em] uppercase text-forest mt-3">{f.role}</p>
                  <p className="text-cream/70 leading-relaxed mt-6">{f.bio}</p>
                  <a
                    href={f.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`founder-linkedin-${i}`}
                    className="group inline-flex items-center gap-2 mt-6 text-cream hover:text-forest transition-colors"
                  >
                    <Linkedin size={18} /> Connect on LinkedIn
                    <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
